module.exports = __webpack_public_path__ + "img/bauges2021-2.2ad93fec.jpeg";